export enum CONTEXT_REQUEST_IDENTIFIERS {
  'GUIDE_TOUR' = 'bw.guide.tour',
  'GUIDE_TOUR_UPDATE' = 'bw.guide.tour.update',
  'GUIDE_TOUR_HOTMART_PRO' = 'hotmart.pro.guide.tour',
  'GUIDE_TOUR_HOTMART_PRO_UPDATE' = 'hotmart.pro.guide.tour.update',
  'MAIN_MENU' = 'menu.main',
  'MAIN_BAR' = 'bar.main',
  'NOTIFICATION_LIST' = 'bw.notification.list',
  'NOTIFICATION_UPDATE' = 'bw.notification.update',
  'NOTIFICATION_CLICK_EVENT' = 'bw.notification.click.event',
  'TYPE_INFO' = 'bw.user.type.info',
  'SIDE_MENU' = 'bw.sidemenu'
}

export enum CONTEXT_BAR_TYPES {
  'REGULAR' = 'REGULAR',
  'ADM' = 'ADM',
  'BLACK' = 'BLACK'
}

export enum MENU_POSITIONS {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  TOOLTIP = 'TOOLTIP'
}
